module.exports = __webpack_public_path__ + "static/media/img_0.bdea8fd2.png";